import { createSlice } from "@reduxjs/toolkit";
import {      home_tradeConfirmationMonthsThunk } from "./thunk";


export const initialState = {
  home_tradeConfirmMonthsData: [],
  home_tradeConfirmMonthsError: {
    code: null,
    message: '',
    data: null
  },
  home_tradeConfirmMonthsLoading: false,
  
  
};

const Home_TradeConfirmMonths = createSlice({
  name: "Home_TradeConfirmMonths",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(home_tradeConfirmationMonthsThunk.pending, (state) => {
      state.home_tradeConfirmMonthsLoading = true ;
      state.home_tradeConfirmMonthsError = initialState.home_tradeConfirmMonthsError; 
      state.home_tradeConfirmMonthsData = [];
  });
    builder.addCase(home_tradeConfirmationMonthsThunk.fulfilled, (state, action) => {
        state.home_tradeConfirmMonthsData = action.payload.data;
        state.home_tradeConfirmMonthsLoading = false ;
    });
    builder.addCase(home_tradeConfirmationMonthsThunk.rejected, (state, action) => {
      state.home_tradeConfirmMonthsError = {
        code: action.payload?.code || null,
        message: action.payload?.message || "An unknown error occurred",
        data: action.payload?.data || null
      };
        state.home_tradeConfirmMonthsLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Home_TradeConfirmMonths.actions

export default Home_TradeConfirmMonths.reducer;